import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { get} from '../../request'
import './styles.scss';


function CheckBox({ className, name, value, onChange, title }) {
    const [isChecked, setIsChecked] = useState(value || false); // 初始化checkbox为未选中状态
    const handleChange = (event) => {
        setIsChecked(event.target.checked); // 更新checkbox的选中状态  
        if (onChange) {
            onChange(event.target.checked);
        }
    };
    useEffect(() => {
              
        if (value != isChecked) {
            setIsChecked(value || false);
        }
    }, [value]);
    return (
        <div className="checkbox-div">
            <input 
                type="checkbox"
                name={name}
                checked={ isChecked}
                onChange={handleChange}
                className={`CheckBox-field ${className}`}
                 id={`cb${name}`}                
            />
            <label htmlFor={`cb${name}`}></label>
            {title}
        </div>
    );
};

export default CheckBox;